import { scoreColor, scoreLabel } from "@/lib/security";

export function SecurityGauge({ score = 0, size = 200, label = true }) {
  const stroke = size * 0.09;
  const r = (size - stroke) / 2;
  const cx = size / 2;
  const cy = size / 2;
  // 270deg arc
  const circumference = 2 * Math.PI * r;
  const arc = 0.75; // fraction of circle used
  const dash = circumference * arc;
  const offset = dash * (1 - score / 100);
  const color = scoreColor(score);

  return (
    <div className="relative inline-flex items-center justify-center" data-testid="security-gauge">
      <svg width={size} height={size} className="-rotate-[135deg]">
        <circle
          cx={cx} cy={cy} r={r} fill="none" stroke="var(--border)" strokeWidth={stroke}
          strokeDasharray={`${dash} ${circumference}`} strokeLinecap="round"
        />
        <circle
          cx={cx} cy={cy} r={r} fill="none" stroke={color} strokeWidth={stroke}
          strokeDasharray={`${dash} ${circumference}`} strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 1.2s cubic-bezier(0.16,1,0.3,1), stroke 0.6s" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-display font-extrabold text-ink" style={{ fontSize: size * 0.24 }} data-testid="gauge-score">
          {score}
        </span>
        {label && (
          <>
            <span className="text-muted font-mono" style={{ fontSize: size * 0.055 }}>/ 100</span>
            <span
              className="mt-1 font-display font-bold tracking-wider"
              style={{ fontSize: size * 0.07, color }}
            >
              {scoreLabel(score)}
            </span>
          </>
        )}
      </div>
    </div>
  );
}
